import Select from "react-select";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";

import ContingenciaPanel from "./ContingenciaPanel";
import CompanyInfo from "./CompanyInfo.js";

const ambiente = [
  { id: 1, value: 1, label: "Modo Prueba" },
  { id: 2, value: 2, label: "Modo produccion" },
];

const initialFormDataDteInfo = {
  clave_publica_dte: "",
  clave_privada_dte: "",
  pwd_dte_mh: "",
  id_ambienteDte: null,
};

const Company = () => {
  const { empresaSeleccionada, empresas } = useSelector((state) => state.auth);

  const [formDataDteInfo, setFormDataDteInfo] = useState(initialFormDataDteInfo);

  const [errores, setErrores] = useState({});

  const [MiEmpresa, setMiEmpresa] = useState({});

  useEffect(() => {
    if (empresas.length > 0) {
      setMiEmpresa(empresaSeleccionada);
    }
  }, [empresaSeleccionada, empresas]);

  useEffect(() => {
    setFormDataDteInfo((prev) => ({
      ...prev,
      id_ambienteDte: MiEmpresa?.id_ambienteDte,
    }));
  }, [MiEmpresa]);

  const handleChangeAux = (e) => {
    const { name, value, type, checked } = e.target;
    setFormDataDteInfo((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectChangeAux = (selectedOption, { name }) => {
    setFormDataDteInfo((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null,
    }));
  };

  const renderInputAux = (label, name, col = 3, disabled = false, type = "text") => (
    <div className={`col-md-${col} mb-3`}>
      <div className="form-floating mb-3 mb-md-0">
        <input
          type={type}
          className="form-control fs-15px"
          placeholder={label}
          name={name}
          value={formDataDteInfo[name] || ""}
          onChange={handleChangeAux}
          disabled={disabled}
        />
        <label className="d-flex align-items-center fs-13px">{label}</label>
      </div>
      {errores[name] && <p style={{ color: "red" }}>* {errores[name]}</p>}
    </div>
  );

  return (
    <div>
      <div className="row">
        <div className="col-md-12 col-12">
          <CompanyInfo />
        </div>

        {empresas.length > 0 && (
          <>
            <div className="col-md-5 col-12">
              <Panel>
                <PanelHeader noButton={true}>Informacion para Emitir DTE</PanelHeader>
                <PanelBody>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">AMBIENTE:</label>
                    <Select
                      name="id_ambienteDte"
                      options={ambiente}
                      value={
                        formDataDteInfo.id_ambienteDte
                          ? {
                              value: formDataDteInfo.id_ambienteDte,
                              label: ambiente?.find((a) => a.id === formDataDteInfo.id_ambienteDte)?.["label"] || "Error..",
                            }
                          : null
                      }
                      isSearchable
                      placeholder="Seleccione un modo"
                      onChange={handleSelectChangeAux}
                    />
                    {errores["id_ambienteDte"] && <p style={{ color: "red" }}>* {errores["id_ambienteDte"]}</p>}
                  </div>
                  {renderInputAux("Contraseña MH-DTE", "pwd_dte_mh", 12, false)}
                  {renderInputAux("Clave publica", "clave_publica_dte", 12, false)}
                  {renderInputAux("Clave privada", "clave_privada_dte", 12, false)}
                </PanelBody>
              </Panel>
            </div>

            <div className="col-md-7 col-12">
              <ContingenciaPanel MiEmpresa={MiEmpresa} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Company;
